<template>
  <li class="overline">
    <span class="font-weight-bold">{{reference}}</span>
    <span>&mdash; {{description}}</span>
  </li>
</template>

<script>
export default {
  name: "ListItem",
  props: {
    reference: String,
    description: String
  }
};
</script>
